// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2gUrS","content":"Consent_content__Qr5UV","footer":"Consent_footer__3IF65"};